import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Dices } from 'lucide-react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export const DiceRoller = ({ show, diceType, setDiceType, diceCount, setDiceCount, diceModifier, setDiceModifier, onRollAndSend, disabled }) => (
  <AnimatePresence>
    {show && (
      <motion.div
        initial={{ height: 0, opacity: 0 }}
        animate={{ height: 'auto', opacity: 1 }}
        exit={{ height: 0, opacity: 0 }}
        className="mb-4 p-4 glass-card rounded-lg border border-blue-400/20"
        data-testid="dice-roller-panel"
      >
        <div className="flex items-center gap-4">
          <div className="w-20">
            <Label className="text-slate-300 text-sm mb-2 block">Count</Label>
            <Input
              type="number"
              min={1}
              max={100}
              value={diceCount}
              onChange={(e) => setDiceCount(Math.max(1, Math.min(100, parseInt(e.target.value) || 1)))}
              className="bg-slate-950/50 border-white/10 text-slate-200"
              data-testid="dice-count-input"
            />
          </div>
          <div className="flex-1">
            <Label className="text-slate-300 text-sm mb-2 block">Dice Type</Label>
            <Select value={diceType} onValueChange={setDiceType}>
              <SelectTrigger className="bg-slate-950/50 border-white/10 text-slate-200">
                <SelectValue />
              </SelectTrigger>
              <SelectContent className="bg-slate-900">
                {['d4', 'd6', 'd8', 'd10', 'd12', 'd20', 'd100'].map(d => (
                  <SelectItem key={d} value={d} className="text-slate-200">{d}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div className="flex-1">
            <Label className="text-slate-300 text-sm mb-2 block">Modifier</Label>
            <Input
              type="number"
              value={diceModifier}
              onChange={(e) => setDiceModifier(parseInt(e.target.value) || 0)}
              className="bg-slate-950/50 border-white/10 text-slate-200"
            />
          </div>
          <Button
            type="button"
            onClick={onRollAndSend}
            disabled={disabled}
            className="bg-blue-500 hover:bg-green-600 text-black font-bold mt-6"
          >
            <Dices className="h-5 w-5 mr-2" />
            Roll {diceCount > 1 ? `${diceCount}${diceType}` : diceType}
          </Button>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);
